
import AxiosAPI from "./AxiosAPI";

export const handleAddCategory = async (data) => {
  try {
    const response = await AxiosAPI.post("/catalog/categories", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add category:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleEditCategory= async (data) => {  
  try {
    const response = await AxiosAPI.put(
      `/catalog/categories/${data.key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const fetchCategory = async () => {
  try {
    const response = await AxiosAPI.get("/catalog/categories");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const deleteCategory = async (key) => { 
  try {
    const response = await AxiosAPI.delete(
      `catalog/categories/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    
  }
};

